import React from 'react'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, FindAgent, CommonList, FigureCards, NewsCard, SuccessStories, CommonBlueCards, PlainText } from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';
import './boat-dealers.scss'
const BoatDealers = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/whoweserve" },
    { label: "Dealerships", link: "/whoweserve/dealershipsinsurance" },
    { label: "Boat dealers", link: "/whoweserve/dealershipsinsurance/boat-dealers" },
  ];



  const HeaderData = [
    {
      para: 'We understand your boat dealership serves a unique market. So when it comes to insurance, your dealership is looking for solutions that address the distinct issues you face. Our plans are customizable, so you get the coverage you want. From property and liability insurance to retirement plans, we offer a variety of products and services built with you in mind. We work with you, to help determine the coverage you need.',
    },
  ];

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const Datalist = [
    "Reduce dealership risks",
    "Safeguard your employees and your facility",
    "Protect your boat inventory",
  ];

  const revenueData = [
    {
      id: 1,
      value: "8",
      unit: "Sentry leaders",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 2,
      value: "$1B+",
      unit: "Paid in claims",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 3,
      value: "1992",
      unit: "First year",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Physical damage insurance',
      description:
        'Weather, animals, other drivers—all things that can damage your vehicle. Let us help cover your costs with physical damage insurance.',
      linkUrl: '',
      linkText: 'More about physical damage insurance >',
    },
    {
      id: 2,
      title: 'Cyber liability insurance',
      description:
        'Data breaches. While we hope they never happen to your business, they are a potential risk. Help protect your company with cyber liability coverage.',
      linkUrl: '/',
      linkText: 'More about cyber liability insurance >',
    },
    {
      id: 3,
      title: 'General liability insurance',
      description:
        'We offer protection against liability claims for your business. Coverage options include product liability, product recall, and errors and omissions.',
      linkUrl: '/',
      linkText: 'More about general liability insurance >',
    },
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Construction resources',
      description:
        'Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: 'Workers’ compensation 101: A guide for employers',
      description:
        'Accidents happen. That’s why workers’ compensation is crucial—and in some states required—to help you protect your business and your employees. This helpful guide explains the complexities of workers’ compensation.',
      linkUrl: '/',
      linkText: 'View guide >',
    },
  ];

  const plaindata = [
    {
      heading: "Boat dealers choose us because we offer custom plans and risk management services.",
      text: "At Sentry, we work with dealers who specialize in all manner of watercraft. We understand your boat dealership is unique, which is why our agents will work with you to create an insurance plan that makes sense for you. But we don’t just offer insurance, we also assist with risk management. We have tools and resources to help you reduce claims. And when claims do happen, our claims staff will be there to simplify the complicated and help protect your bottom line.",
      linkText: "View resources",
      linkUrl: "/resources"
    },
  ]

  return (
    <>
      <div className='contruction-main'>
        {/* hero section */}
        <Hero img={images["BoatDealership.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Insurance for boat dealers" showshare={true} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} showImage={false} />

          {/*common list section */}
          <CommonList Heading="We can help boat dealers:" list={Datalist} />

          {/* heading text */}
          <PlainText data={plaindata} />

          {/* figure cards */}
          <FigureCards data={revenueData} heading={'Significant figures'} />

          {/* products cards */}
          <NewsCard Title="Products for boat dealerships" CardData={ProductCardData} showNavLink={false} subTitle="PRODUCTS" />

          {/* success stories */}
          <SuccessStories />

          {/* resorce data */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources or services" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default BoatDealers;